export default __webpack_public_path__ + "static/media/cs-a018-5.7a15df16.svg";